// extracted by mini-css-extract-plugin
export var productImage = "_mt-0";